import Chat from './chat/SettingsSupportChat';
import Threads from './thread/SettingsSupportThread';
import Create from './create/CreateSupportThreadChat'

export default { Chat, Threads, Create };
